export enum ProctorTestNames {
    IMS_MP_JS_SHOW_RECIPIENTS_TST = 'ims_mp_js_show_recipients',
    MESSAGING_ARC_AI_ASSISTED_MESSAGING = 'messaging_arc_ai_assisted_messaging_ff',
    MESSAGING_ARC_AI_ASSISTED_REWRITE_ONLY = 'messaging_arc_ai_assisted_rewrite_only_ff',
    MESSAGING_SEND_CORRELATION_ENABLED = 'messaging_send_correlation_enabled',
    AI_MESSAGING_FRONTEND_MIGRATION = 'ai_messaging_frontend_migration_ff',
    AI_MESSAGING_FOLLOW_UP_PROMPT = 'ai_messaging_follow_up_prompt_ff',
    AIMS_AI_ASSISTED_REWRITE_ONLY = 'aims_ai_assisted_rewrite_only_ff',
    AIMS_JS_AI_MESSAGING_VERSION_TWO = 'aims_js_ai_messaging_version_two',
    COMMSEXP_JOBSEEKER_SERVICE_DEGRADATION_BANNER = 'commsexp_jobseeker_service_degradation_banner',
    AMPL_JS_AUTOSIZE_COMPOSEBOX_TST = 'ampl_js_autosize_composebox_tst',
    IMS_JS_DISPLAY_CONVERSATION_TITLE = 'ims_js_display_conversation_title',
}

export enum ProctorPayloadTypes {
    LONG_ARRAY = 'longArray',
    STRING = 'stringValue',
    LONG_VALUE = 'longValue',
    JSON = 'json',
}

export enum ProctorCommonGroupNames {
    INACTIVE = 'inactive',
    CONTROL = 'control',
    ACTIVE = 'active',
}

export enum ProctorCommonGroupValues {
    INACTIVE = -1,
    CONTROL = 0,
    ACTIVE = 1,
}
